"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePasswordReset = void 0;
// Custom Hooks
var react_1 = require("react");
var usePasswordReset = function () {
    var _a = (0, react_1.useState)(), csrfToken = _a[0], setCsrfToken = _a[1];
    var isDisabled = function (isValid, isLoading, errors) {
        return !isValid || Object.keys(errors).length > 0 || isLoading;
    };
    (0, react_1.useEffect)(function () {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- 暫定対応
        var csrfTokenMeta = document.head.querySelector('meta[name="csrf-token"]');
        if (csrfTokenMeta) {
            var csrfToken_1 = csrfTokenMeta.content;
            setCsrfToken(csrfToken_1);
        }
    }, []);
    return {
        isDisabled: isDisabled,
        csrfToken: csrfToken,
    };
};
exports.usePasswordReset = usePasswordReset;
